import React from 'react';

import { Contract } from '@/types/ContractType';

const GoverningLaw = ({ contract }: { contract: Contract }) => {
  // Priority: product address > agentSellerInfo > fallback
  const propertyState =
    contract?.product?.address?.state ||
    contract?.agentSellerInfo?.propertyState ||
    'N/A';

  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Governing Law, Venue and Personal Jurisdiction
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          The validity and construction of this Agreement, and the rights and
          duties of the parties, will be governed in accordance with the laws of{' '}
          {propertyState}.
        </li>
        <li>
          The parties agree that any dispute, controversy or claim arising under
          or in connection with this Agreement or its performance by either
          party submitted to a court shall be filed exclusively by and in the
          state or federal courts sitting in {propertyState}.
        </li>
      </ol>
    </div>
  );
};

export default GoverningLaw;
